import React, { useEffect, useState } from "react";
import { Box, useBreakpointValue } from "@chakra-ui/react";
import { VdoCipherPlayer } from "@components/VdoCipherPlayer/vdo-cipher-player.tsx"

const MargazhiTestimonialsVideoPopup = ({ videoData, videoIndx, setVideoIndx, setRefresh }) => {
    let closeIconSize = useBreakpointValue({ base: '32px', md: 'auto' })

    let [vdoProgress, setVdoProgress] = useState(0)
    let [isMuted, setIsMuted] = useState(false)
    const [width, setWidth] = useState(0);


    useEffect(() => {
        const update = () => setWidth(window.innerWidth - 20);
        update();
        window.addEventListener("resize", update);
        return () => window.removeEventListener("resize", update);
    }, []);

    function onVideoComplete() {
        setVideoIndx(videoIndx => {
            // console.log("onVideoComplete", videoIndx, videoData.length - 1);
            if (videoIndx/1 < (videoData.length - 1)/1) {
                return videoIndx + 1                  
            }
            else {
              return 0
            }
        })
    }

    return (
        <Box display={videoIndx == null ? "none" : "block"}>
            <Box
                position="fixed"
                inset="0"
                zIndex="overlay"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Box
                    bg="#0D0D0D"
                    w={"100%"}
                    h={'100%'}
                    overflow="hidden"
                    position="relative"
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                >

                    <Box
                        height={'100vh'}
                        bgColor={'black'}
                        width={{ base: `${width}px`, md: '486px' }}
                        justifySelf={'center'} alignSelf={'center'} alignItems={'center'}
                        display={'flex'} justifyContent={'center'} flexDir={'row'}
                    >
                        <Box display={'flex'} flexDir={'row'}
                            position={'fixed'} justifyContent={'space-between'}
                            width={{ base: `${width}px`, md: '486px' }} top={{ base: '1rem', md: '1.5rem' }} zIndex={10}
                        >
                            {videoData.map((i, j) => {
                                if (i.videoId) {
                                    return <Box key={j} width={{ base: `${(width / 1 - 20) / videoData?.filter(i => i.videoId)?.length}px`, md: `${460 / videoData?.filter(i => i.videoId)?.length}px` }} borderRadius={'2px'}
                                        height={{ base: '2px', md: '4px' }} bgColor={'#FFFFFF4D'}>
                                        <Box width={j / 1 < videoIndx / 1 ? '100%' : (j / 1 == videoIndx / 1 ? `${vdoProgress}%` : '0px')} height={'100%'} bgColor={'#fff'} />
                                    </Box>
                                }
                            })}
                        </Box>

                        <Box position={'absolute'} top={{ base: '2rem', md: '3rem' }} width={{ base: `${width}px`, md: '486px' }}
                            mx={'auto'} zIndex={11} display={'flex'}  >
                            <svg
                                onClick={() => { setVideoIndx(null); setRefresh(ref => ref + 1); setIsMuted(false)}}
                                style={{
                                    marginLeft: 'auto', marginRight: '1rem', cursor: 'pointer',
                                    width: closeIconSize, height: closeIconSize
                                }} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="40" height="40" rx="20" fill="#1D1A16" />
                                <path d="M13 13L27 27M27 13L13 27" stroke="white" stroke-width="2" stroke-linecap="round" />
                            </svg>

                        </Box>

                        {videoData.map((i, j) => {
                                return <Box
                                    key={j}
                                    display={j / 1 == videoIndx / 1 ? 'block' : 'none'} width={'100%'}>
                                    <VdoCipherPlayer
                                        id={`${j}${new Date().getTime()}Popup`}
                                        videoId={videoData?.[j]?.videoId}
                                        controlAutoPlay={true}
                                        startVideoInUseEffect={videoIndx != null && j / 1 == videoIndx / 1}
                                        hidePlayPauseIcon={true}
                                        hideFullScreen={true}
                                        hideSoundIcon={true}
                                        hideDragProgBar={true}
                                        vdoProgress={vdoProgress}
                                        onVideoProgress={({ percentage }) => {
                                            setVdoProgress(percentage / 1 * 100)
                                        }}
                                        onComplete={() => {
                                            onVideoComplete()
                                        }}
                                        videoControllerForShorts={{ base: `${width}px`, md: '486px' }}
                                        aspectRatio={'9/16'}
                                        shortsVideo={true}
                                        muteStatus={isMuted}
                                        onMuteStatusChange={setIsMuted}
                                        videoData={videoData}
                                        videoIndx={videoIndx}
                                        setVideoIndx={setVideoIndx}
                                        navArrowBarW={{ base: `${width}px`, md: '680px' }}
                                    />
                                </Box>
                        })}
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default MargazhiTestimonialsVideoPopup;